import { combineReducers } from 'redux';
import userReducer from './userReducer';
import authReducer from './authReducer';
import apiReducer from './apiReducer';
import todoReducer from './todoReducer';
import generalReducer from './generalReducer';
import selectListReducer from './selectListItemReducer';
import portalReducer from './portalReducer';
import accessTokenReducer from './accessTokenReducer';
import commentReducer from './commentReducer';
import storageReducer from './storageReducer';
import syncUsersReducer from './syncUsersReducer';
import notificationReducer from './notificationReducer';

export default combineReducers({
    user: userReducer,
    auth: authReducer,
    api: apiReducer,
    todo: todoReducer,
    general: generalReducer,
    selectList: selectListReducer,
    portal: portalReducer,
    accessToken: accessTokenReducer,
    comment: commentReducer,
    storage: storageReducer,
    syncUsers: syncUsersReducer,
    notification: notificationReducer
});
